(function () {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const drawer = document.querySelector('#CartDrawer');
  const scrim = document.querySelector('[data-cart-scrim]');
  const searchPanel = document.querySelector('#SearchPanel');
  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';
  let lastCartTrigger = null;
  let lastSearchTrigger = null;

  const money = (value, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency || 'USD' }).format(value / 100);
  const escapeHtml = value => String(value || '').replace(/[&<>'"]/g, char => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', "'":'&#39;', '"':'&quot;' }[char]));
  const displayTitle = value => String(value || '').split(/[—–]/)[0].trim();

  function syncOverlayState() {
    const overlayOpen = drawer?.classList.contains('open') || searchPanel?.classList.contains('open');
    document.body.classList.toggle('overlay-open', Boolean(overlayOpen));
  }

  function setCartOpen(open, trigger) {
    if (!drawer) return;
    if (open) {
      lastCartTrigger = trigger || document.activeElement;
      setSearchOpen(false);
    }
    drawer.classList.toggle('open', open);
    scrim?.classList.toggle('open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    document.querySelectorAll('[data-cart-open]').forEach(element => element.setAttribute('aria-expanded', String(open)));
    syncOverlayState();
    if (open) window.requestAnimationFrame(() => drawer.querySelector('[data-cart-close]')?.focus());
    if (!open && lastCartTrigger instanceof HTMLElement) lastCartTrigger.focus();
  }

  function setSearchOpen(open, trigger) {
    if (!searchPanel) return;
    if (open) {
      lastSearchTrigger = trigger || document.activeElement;
      if (drawer?.classList.contains('open')) setCartOpen(false);
    }
    searchPanel.classList.toggle('open', open);
    searchPanel.setAttribute('aria-hidden', String(!open));
    document.querySelectorAll('[data-search-open]').forEach(element => element.setAttribute('aria-expanded', String(open)));
    syncOverlayState();
    if (open) window.requestAnimationFrame(() => searchPanel.querySelector('input')?.focus());
    if (!open && lastSearchTrigger instanceof HTMLElement) lastSearchTrigger.focus();
  }

  function trapFocus(event, container) {
    if (event.key !== 'Tab' || !container) return;
    const focusable = Array.from(container.querySelectorAll(focusableSelector)).filter(element => element.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  function showCartError(message) {
    const error = document.querySelector('[data-cart-error]');
    if (!error) return;
    error.textContent = message || '';
    error.hidden = !message;
  }

  function cartItemMarkup(item, currency) {
    const title = displayTitle(item.product_title);
    const image = item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(title)}" loading="lazy">` : '<div class="image-placeholder">Image coming soon</div>';
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p>${escapeHtml(item.variant_title)}</p>` : '';
    return `<div class="cart-line" data-cart-line="${escapeHtml(item.key)}"><div class="cart-thumb">${image}</div><div><h3>${escapeHtml(title)}</h3>${variant}<div class="quantity"><button type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button></div></div><div class="line-actions"><strong>${money(item.final_line_price, currency)}</strong><button type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="0">Remove</button></div></div>`;
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(element => { element.textContent = cart.item_count; });
    document.querySelectorAll('[data-cart-subtotal]').forEach(element => { element.textContent = money(cart.total_price, cart.currency); });
    document.querySelectorAll('[data-cart-discount]').forEach(element => { element.textContent = `-${money(cart.total_discount || 0, cart.currency)}`; });
    document.querySelectorAll('[data-cart-discount-row]').forEach(element => { element.hidden = !(cart.total_discount > 0); });
    document.querySelectorAll('[data-cart-checkout]').forEach(element => { element.disabled = cart.item_count === 0; });
    const items = document.querySelector('[data-cart-items]');
    if (!items) return;
    items.innerHTML = cart.item_count ? cart.items.map(item => cartItemMarkup(item, cart.currency)).join('') : '<div class="empty-state"><h2>Your bag is open.</h2><p>Choose a crystal to begin.</p></div>';
  }

  async function refreshCart(open = false, trigger = null) {
    const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Your bag could not be loaded. Please try again.');
    const cart = await response.json();
    renderCart(cart);
    if (open) setCartOpen(true, trigger);
    return cart;
  }

  async function addForm(form) {
    const button = form.querySelector('[data-add-button], .quick-add');
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    showCartError('');
    try {
      const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('This item could not be added. Please check the selected option.');
      await refreshCart(true, button);
    } catch (error) {
      showCartError(error.message);
      setCartOpen(true, button);
    } finally {
      if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
    }
  }

  async function changeLine(key, quantity) {
    showCartError('');
    try {
      const response = await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: Number(quantity) }) });
      if (!response.ok) throw new Error('Your bag could not be updated. Please try again.');
      renderCart(await response.json());
    } catch (error) { showCartError(error.message); }
  }

  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-product-form]');
    if (form) { event.preventDefault(); addForm(form); }
  });

  document.addEventListener('click', event => {
    const backLink = event.target.closest('[data-smart-back]');
    if (backLink && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      let previousIsStorePage = false;
      try {
        previousIsStorePage = Boolean(document.referrer) && new URL(document.referrer).origin === window.location.origin;
      } catch (error) {
        previousIsStorePage = false;
      }
      if (previousIsStorePage && window.history.length > 1) {
        event.preventDefault();
        window.history.back();
        return;
      }
    }
    const cartOpen = event.target.closest('[data-cart-open]');
    const cartClose = event.target.closest('[data-cart-close]');
    const cartChange = event.target.closest('[data-cart-change]');
    const stickyAdd = event.target.closest('[data-sticky-add]');
    const menu = event.target.closest('[data-menu-toggle]');
    const searchOpen = event.target.closest('[data-search-open]');
    const searchClose = event.target.closest('[data-search-close]');
    if (cartOpen) refreshCart(true, cartOpen).catch(error => { showCartError(error.message); setCartOpen(true, cartOpen); });
    if (cartClose || event.target === scrim) setCartOpen(false);
    if (cartChange) changeLine(cartChange.dataset.cartChange, cartChange.dataset.quantity);
    if (stickyAdd) document.querySelector('.product-detail-form')?.requestSubmit();
    if (menu) {
      const nav = document.querySelector('#MobileNav');
      const open = !nav.classList.contains('open');
      nav.classList.toggle('open', open);
      nav.hidden = !open;
      menu.setAttribute('aria-expanded', String(open));
    }
    if (searchOpen) setSearchOpen(true, searchOpen);
    if (searchClose) setSearchOpen(false);
  });

  document.addEventListener('click', event => {
    const adjust = event.target.closest('[data-qty-adjust]');
    if (!adjust) return;
    const input = adjust.parentElement.querySelector('input');
    if (input) input.value = Math.max(1, Number(input.value || 1) + Number(adjust.dataset.qtyAdjust));
  });

  document.addEventListener('change', event => {
    const select = event.target.closest('[data-variant-select]');
    if (!select) return;
    const option = select.options[select.selectedIndex];
    document.querySelectorAll('[data-product-price], [data-sticky-price]').forEach(element => { element.textContent = option.dataset.price; });
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      if (drawer?.classList.contains('open')) setCartOpen(false);
      if (searchPanel?.classList.contains('open')) setSearchOpen(false);
    }
    if (drawer?.classList.contains('open')) trapFocus(event, drawer);
    if (searchPanel?.classList.contains('open')) trapFocus(event, searchPanel);
  });
})();
